import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [CommonModule, RouterLink, ButtonModule],
  template: `
    <div class="not-found-container">
      <div class="content">
        <h1 class="error-code">404</h1>
        <h2>Страница не найдена</h2>
        <p>К сожалению, запрашиваемая страница не существует.</p>
        <p-button 
          label="Вернуться на главную" 
          icon="pi pi-home"
          [routerLink]="['/']"
          styleClass="p-button-primary">
        </p-button>
      </div>
    </div>
  `,
  styles: [`
    .not-found-container {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 80vh;
      padding: 20px;
    }

    .content {
      text-align: center;
      max-width: 500px;
    }

    .error-code {
      font-size: 8rem;
      font-weight: bold;
      color: var(--primary-color);
      margin: 0;
      line-height: 1;
    }

    h2 {
      font-size: 2rem;
      color: var(--color-main-font);
      margin: 20px 0 10px;
    }

    p {
      font-size: 1.1rem;
      color: var(--color-grey-font);
      margin-bottom: 30px;
    }
  `]
})
export class NotFoundComponent {}